const getCurrentTimeStamp = () => {
  return Math.round(window.performance.now());
};

export default getCurrentTimeStamp;